module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": this.area.list,
      "props": {
        checkStrictly: true
      },
      "size": "mini",
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    },
    model: {
      value: (_vm.selected_office_area_id),
      callback: function($$v) {
        _vm.selected_office_area_id = $$v
      },
      expression: "selected_office_area_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "mini",
      "placeholder": "选择标签",
      "options": _vm.tag.list,
      "props": {
        value: 'tag_id',
        label: 'tag_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.TagChangeAction
    },
    model: {
      value: (_vm.params.dis_tag_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "dis_tag_id", $$v)
      },
      expression: "params.dis_tag_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.setMarketPrice
    }
  }, [_vm._v("设置区域划线价")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多个货号之间使用英文逗号 ',' 分隔",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.item_bns),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bns", $$v)
      },
      expression: "params.item_bns"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多个店铺ID之间使用英文逗号 ',' 分隔",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.inca_ids),
      callback: function($$v) {
        _vm.$set(_vm.params, "inca_ids", $$v)
      },
      expression: "params.inca_ids"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "店铺ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "原价",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                ￥" + _vm._s(scope.row.market_price / 100) + "\n              ")]
      }
    }], null, false, 2933027760)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area_market_price",
      "label": "区域划线价",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                ￥" + _vm._s(scope.row.area_market_price / 100) + "\n              ")]
      }
    }], null, false, 1385925176)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [20, 50, 100, 200],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fef3e146", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fef3e146"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/areaMarketPrice/list.vue
// module id = 3006
// module chunks = 0